import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Clock, ArrowRight, Mail, Sparkles } from "lucide-react";
import MadridGallery from "../components/MadridGallery";
import AlcobendasGallery from "../components/AlcobendasGallery";

const CentersPage = () => {
  return (
    <main data-testid="centers-page">
      {/* HERO */}
      <section className="py-20 px-6" style={{ background: "var(--bg-soft)" }}>
        <div className="max-w-5xl mx-auto fade-up">
          <span className="section-eyebrow">Dónde encontrarnos</span>
          <h1 className="section-title mt-4">
            Nuestros <span className="handwritten">centros</span>
          </h1>
          <p className="font-sans-body text-[color:var(--ink-soft)] mt-6 max-w-2xl text-lg">
            Dos espacios cuidados al detalle — pensados para que te sientas cómodo/a desde que entras. Cada rincón está diseñado para acompañarte en tu mejor experiencia visual.
          </p>
        </div>
      </section>

      {/* MADRID */}
      <section className="py-20 px-6" id="madrid">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full font-sans-body text-xs font-semibold" style={{ background: "var(--sage-500)", color: "var(--cream)" }}>
                ✦ Centro principal
              </div>
              <h2 className="section-title mt-4" style={{ fontSize: "clamp(1.8rem, 3.5vw, 2.8rem)" }}>
                Madrid · <span className="handwritten">Alcalde López Casero</span>
              </h2>
            </div>
          </div>

          {/* Galería de fotos del centro de Madrid con lightbox */}
          <MadridGallery />

          {/* Info + Mapa */}
          <div className="grid md:grid-cols-2 gap-8 mt-10">
            <div className="soft-card">
              <h3 className="section-eyebrow">Información</h3>
              <div className="mt-5 space-y-5 font-sans-body">
                <div className="flex gap-4">
                  <div className="h-10 w-10 rounded-full flex items-center justify-center shrink-0" style={{ background: "var(--sage-100)" }}><MapPin size={18} style={{ color: "var(--sage-600)" }} /></div>
                  <div>
                    <div className="font-semibold text-[color:var(--ink)]">Dirección</div>
                    <div className="text-sm text-[color:var(--ink-soft)]">C/ Alcalde López Casero 10<br />Madrid</div>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="h-10 w-10 rounded-full flex items-center justify-center shrink-0" style={{ background: "var(--sage-100)" }}><Phone size={18} style={{ color: "var(--sage-600)" }} /></div>
                  <div>
                    <div className="font-semibold text-[color:var(--ink)]">Teléfonos</div>
                    <div className="text-sm text-[color:var(--ink-soft)]"><span className="text-xs uppercase tracking-widest" style={{ color: "var(--sage-600)" }}>General</span> · 91 404 48 77<br /><span className="text-xs uppercase tracking-widest" style={{ color: "var(--sage-600)" }}>Terapia visual</span> · 657 95 78 21<br /><span className="text-xs uppercase tracking-widest" style={{ color: "var(--sage-600)" }}>Óptica</span> · 640 81 23 28</div>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="h-10 w-10 rounded-full flex items-center justify-center shrink-0" style={{ background: "var(--sage-100)" }}><Clock size={18} style={{ color: "var(--sage-600)" }} /></div>
                  <div>
                    <div className="font-semibold text-[color:var(--ink)]">Horario</div>
                    <div className="text-sm text-[color:var(--ink-soft)]">Lunes a Viernes · 10:00 — 14:30 y 16:30 — 20:00<br />Sábados · 10:15 — 14:00</div>
                  </div>
                </div>
              </div>
              <a href="/#contacto" className="btn-primary mt-7" data-testid="madrid-cta">Pedir cita en Madrid <ArrowRight size={16} /></a>
            </div>
            <iframe title="Mapa Madrid" className="w-full h-full min-h-[320px] rounded-3xl border-0" src="https://www.google.com/maps?q=Calle+Alcalde+Lopez+Casero+10,+Madrid&output=embed"></iframe>
          </div>
        </div>
      </section>

      {/* ALCOBENDAS */}
      <section className="py-20 px-6" id="alcobendas" style={{ background: "var(--sage-50)" }}>
        <div className="max-w-6xl mx-auto">
          <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full font-sans-body text-xs font-semibold" style={{ background: "var(--sage-500)", color: "var(--cream)" }}>
                ✦ Nuevo centro
              </div>
              <h2 className="section-title mt-4" style={{ fontSize: "clamp(1.8rem, 3.5vw, 2.8rem)" }}>
                Alcobendas · <span className="handwritten">Paseo de Fuente Lucha</span>
              </h2>
              <p className="font-sans-body text-[color:var(--ink-soft)] mt-4 max-w-xl">
                Nuestro segundo centro en Alcobendas, para estar más cerca de las familias del norte de Madrid. Ya puedes pedir tu cita.
              </p>
            </div>
          </div>

          {/* Galería de fotos reales del nuevo centro */}
          <AlcobendasGallery />

          {/* Info + Mapa (estilo Madrid) */}
          <div className="grid md:grid-cols-2 gap-8 mt-10">
            <div className="soft-card">
              <h3 className="section-eyebrow">Información</h3>
              <div className="mt-5 space-y-5 font-sans-body">
                <div className="flex gap-4">
                  <div className="h-10 w-10 rounded-full flex items-center justify-center shrink-0" style={{ background: "var(--sage-100)" }}><MapPin size={18} style={{ color: "var(--sage-600)" }} /></div>
                  <div>
                    <div className="font-semibold text-[color:var(--ink)]">Dirección</div>
                    <div className="text-sm text-[color:var(--ink-soft)]">Paseo de Fuente Lucha 5<br />28100 Alcobendas</div>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="h-10 w-10 rounded-full flex items-center justify-center shrink-0" style={{ background: "var(--sage-100)" }}><Phone size={18} style={{ color: "var(--sage-600)" }} /></div>
                  <div>
                    <div className="font-semibold text-[color:var(--ink)]">Teléfonos</div>
                    <div className="text-sm text-[color:var(--ink-soft)]">
                      <span className="text-xs uppercase tracking-widest" style={{ color: "var(--sage-600)" }}>General</span> · <a href="tel:+34915198787" className="hover:underline">91 519 87 87</a><br />
                      <span className="text-xs uppercase tracking-widest" style={{ color: "var(--sage-600)" }}>Terapia visual</span> · <a href="tel:+34657957821" className="hover:underline">657 95 78 21</a><br />
                      <span className="text-xs uppercase tracking-widest" style={{ color: "var(--sage-600)" }}>Óptica</span> · <a href="tel:+34629353459" className="hover:underline">629 35 34 59</a>
                    </div>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="h-10 w-10 rounded-full flex items-center justify-center shrink-0" style={{ background: "var(--sage-100)" }}><Clock size={18} style={{ color: "var(--sage-600)" }} /></div>
                  <div>
                    <div className="font-semibold text-[color:var(--ink)]">Horario</div>
                    <div className="text-sm text-[color:var(--ink-soft)]">Lunes a Viernes · 10:00 — 14:00 y 16:30 — 20:00<br />Sábados · 10:30 — 14:00</div>
                  </div>
                </div>
              </div>
              <a href="/#contacto" className="btn-primary mt-7" data-testid="alcobendas-cta">Pedir cita en Alcobendas <ArrowRight size={16} /></a>
            </div>
            <iframe title="Mapa Alcobendas" className="w-full h-full min-h-[320px] rounded-3xl border-0" src="https://www.google.com/maps?q=Paseo+de+Fuente+Lucha+3,+28100+Alcobendas,+Madrid&hl=es&z=17&output=embed"></iframe>
          </div>
        </div>
      </section>

      {/* CTA final */}
      <section className="py-16 px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="section-title" style={{ fontSize: "clamp(1.6rem, 3vw, 2.2rem)" }}>
            Siempre <span className="handwritten">cerca de ti</span>
          </h2>
          <p className="font-sans-body text-[color:var(--ink-soft)] mt-4">
            Dos espacios, un mismo cuidado. Elige el que te quede mejor y ven a conocernos.
          </p>
          <div className="mt-8 flex flex-wrap gap-3 justify-center">
            <Link to="/servicios" className="btn-ghost" data-testid="centers-cta-services">Ver servicios <ArrowRight size={16} /></Link>
            <Link to="/servicios#autoevaluacion" className="btn-primary" data-testid="centers-cta-autoeval">Haz tu autoevaluación <ArrowRight size={16} /></Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default CentersPage;
